import _toConsumableArray from "/home/runner/work/me/me/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/runner/work/me/me/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/esnext.aggregate-error.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/es.string.trim-start.js";
import "core-js/modules/es.string.trim-end.js";

/*! Copyright (c) 2021-present the Fonction authors. All rights reserved. MIT license. */

/*! Copyright (c) 2021-present the Curry authors. All rights reserved. MIT license. */
var r = function r(_r2) {
  var e = function e() {
    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    return t.length >= _r2.length ? _r2.apply(void 0, t) : e.bind.apply(e, [null].concat(t));
  };

  return e;
},
    e = function e(r) {
  return "function" == typeof r;
},
    t = function t(r) {
  return !!r;
},
    o = function o(r, _o, n) {
  return (e(r) ? t(r()) : t(r)) ? e(_o) ? _o() : _o : e(n) ? n() : n;
},
    n = function n(r) {
  return o(e(r), function () {
    return r();
  }, r);
},
    s = function s(r, e) {
  return o(t(n(r)), function () {
    return t(n(e));
  }, !1);
},
    i = function i(r, e, t) {
  return t.slice(r, e);
},
    a = Object.prototype,
    c = Object.entries,
    y = Object.keys,
    l = Object.values,
    u = a.hasOwnProperty,
    f = function f(r) {
  return null === r;
},
    m = function m(r) {
  return void 0 === r;
},
    p = function p(r, e) {
  return t(n(r)) || t(n(e));
},
    g = function g(r) {
  return !r;
},
    b = function b(r) {
  return o(s(g(function (r) {
    return p(m(r), function () {
      return f(r);
    });
  }(r)), function () {
    return r.constructor;
  }), function () {
    var _r$constructor$name;

    return (_r$constructor$name = r.constructor.name) !== null && _r$constructor$name !== void 0 ? _r$constructor$name : "";
  }, "");
},
    d = function d(r) {
  return "number" == typeof r;
},
    v = function v(r) {
  return "string" == typeof r;
},
    A = function A(r) {
  return c(r);
},
    h = function h(r) {
  return Array.isArray(r);
},
    S = function S(r) {
  return r.length;
},
    E = function E(r, e) {
  return o(function (r, e) {
    return r < e;
  }(r, 0), function () {
    return e.slice(r);
  }, function () {
    return i(0, r, e);
  });
},
    O = function O(r, e) {
  return u.call(e, r);
},
    U = function U(r) {
  return "bigint" == typeof r;
},
    j = function j(r) {
  return "boolean" == typeof r;
},
    R = function R(r) {
  return p(m(r), function () {
    return f(r);
  });
},
    w = function w(r) {
  return "symbol" == typeof r;
},
    L = function L(r) {
  return [R, j, d, v, U, w].some(function (e) {
    return e(r);
  });
},
    I = function I(r) {
  return g(L(r));
},
    P = function P(r, e) {
  var t = function (r) {
    return o(h(r), function () {
      return o(S(r), function () {
        return E(1, r)[0];
      }, void 0);
    }, function () {
      return E(1, r);
    });
  }(r);

  if (m(t)) return !1;

  var n = function (r) {
    return i(1, 1 / 0, r);
  }(r);

  return function (r) {
    return o(p(v(r), function () {
      return h(r);
    }), function () {
      return g(S(r));
    }, !1);
  }(n) ? O(t, e) : o(s(O(t, e), function () {
    return I(e[t]);
  }), function () {
    return P(n, e[t]);
  }, !1);
},
    B = function B(r) {
  return "Object" === b(r);
},
    N = function N(r) {
  return function (e, t) {
    return s(r(e), function () {
      return r(t);
    });
  };
},
    x = function x(r) {
  return function (e, t) {
    return s(e instanceof r, function () {
      return t instanceof r;
    });
  };
},
    C = N(h),
    T = N(e),
    k = N(B),
    z = N(L),
    F = N(function (r) {
  return s(I(r), function () {
    return g(B(r));
  });
}),
    W = x(Date),
    _ = x(RegExp),
    D = x(Error),
    M = x(Map),
    q = x(Set),
    G = x(URL),
    H = x(ArrayBuffer),
    J = x(URLSearchParams),
    K = function K(r, e) {
  return [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array, BigInt64Array, BigUint64Array].some(function (t) {
    return x(t)(r, e);
  });
},
    Q = Object.is,
    V = Object.getOwnPropertySymbols,
    X = function X(r) {
  return V(r).map(function (e) {
    return [e, r[e]];
  });
},
    Y = function Y(r, e) {
  return e instanceof r;
},
    Z = function Z(r, e) {
  if (!$(r, e)) return !1;
  var t = [[z, rr], [k, lr], [C, fr], [W, or], [T, sr], [_, tr], [D, nr], [M, ir], [q, ar], [K, mr], [H, pr], [G, gr], [J, br], [F, ur]];

  for (var _i = 0, _t = t; _i < _t.length; _i++) {
    var _t$_i = _slicedToArray(_t[_i], 2),
        _o2 = _t$_i[0],
        _n = _t$_i[1];

    if (_o2(r, e)) return _n(r, e);
  }

  return !1;
},
    $ = function $(r, e) {
  return b(r) === b(e);
},
    rr = function rr(r, e) {
  return p(Q(r, e), function () {
    return r === e;
  });
},
    er = function er(r, e, t) {
  return s(Y(r, e), function () {
    return Y(r, t);
  });
},
    tr = function tr(r, e) {
  return r.toString() === e.toString();
},
    or = function or(r, e) {
  return rr(r.getTime(), e.getTime());
},
    nr = function nr(r, e) {
  return r.message === e.message && (!![EvalError, RangeError, ReferenceError, SyntaxError, TypeError, URIError].some(function (t) {
    return er(t, r, e);
  }) || o(er(AggregateError, r, e), function () {
    return fr(r.errors, e.errors);
  }, function () {
    return $(r, e);
  }));
},
    sr = function sr(r, e) {
  return r.toString() === e.toString();
},
    ir = function ir(r, e) {
  return r.size === e.size && yr(_toConsumableArray(r), _toConsumableArray(e));
},
    ar = function ar(r, e) {
  return fr(_toConsumableArray(r), _toConsumableArray(e));
},
    cr = function cr(_ref, _ref2) {
  var _ref3 = _slicedToArray(_ref, 2),
      r = _ref3[0],
      e = _ref3[1];

  var _ref4 = _slicedToArray(_ref2, 2),
      t = _ref4[0],
      o = _ref4[1];

  return s(Z(r, t), function () {
    return Z(e, o);
  });
},
    yr = function yr(r, e) {
  return S(r) === S(e) && s(r.every(function (r) {
    return e.some(function (e) {
      return cr(r, e);
    });
  }), function () {
    return e.every(function (e) {
      return r.some(function (r) {
        return cr(r, e);
      });
    });
  });
},
    lr = function lr(r, e) {
  var t = [].concat(_toConsumableArray(A(r)), _toConsumableArray(X(r))),
      o = [].concat(_toConsumableArray(A(e)), _toConsumableArray(X(e)));
  return S(t) === S(o) && t.every(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        r = _ref6[0],
        t = _ref6[1];

    return s(function (r, e) {
      return h(r) ? P(r, e) : O(r, e);
    }(r, e), function () {
      return Z(t, e[r]);
    });
  });
},
    ur = function ur(r, e) {
  return !![Number, String, Boolean].some(function (t) {
    return er(t, r, e);
  }) && Z(r.valueOf(), e.valueOf());
},
    fr = function fr(r, e) {
  var t = S(r),
      o = S(e);
  return !!s(g(t), function () {
    return g(o);
  }) || t === o && r.every(function (r, t) {
    return Z(r, e[t]);
  });
},
    mr = function mr(r, e) {
  return fr(_toConsumableArray(r), _toConsumableArray(e));
},
    pr = function pr(r, e) {
  return r.byteLength === e.byteLength;
},
    gr = function gr(r, e) {
  return r.toString() === e.toString();
},
    br = function br(r, e) {
  return yr(_toConsumableArray(r), _toConsumableArray(e));
},
    dr = function dr(r) {
  return void 0 === r;
},
    vr = function vr(r) {
  return "symbol" == typeof r;
},
    Ar = function Ar(r, e) {
  return dr(e) ? function (e) {
    return Ar(e, r);
  } : r + e;
},
    hr = Symbol("_"),
    Sr = function Sr(r, e) {
  if (r === hr) return e;
  throw Error("Placeholder is invalid Symbol");
},
    Er = function Er(r, e) {
  return dr(e) ? function (e) {
    return Er(r, e);
  } : vr(r) ? Sr(r, function (r) {
    return Er(r, e);
  }) : r / e;
},
    Or = function Or(r, e) {
  return dr(e) ? function (e) {
    return Or(e, r);
  } : r * e;
},
    Ur = function Ur(r, e) {
  return dr(e) ? function (e) {
    return Ur(r, e);
  } : vr(r) ? Sr(r, function (r) {
    return Ur(r, e);
  }) : r - e;
},
    jr = Ar,
    Rr = function Rr(r) {
  return "function" == typeof r;
},
    wr = function wr(r) {
  return !!r;
},
    Lr = function Lr(r, e, t) {
  return (Rr(r) ? wr(r()) : wr(r)) ? Rr(e) ? e() : e : Rr(t) ? t() : t;
},
    Ir = function Ir(r) {
  return Lr(Rr(r), function () {
    return r();
  }, r);
},
    Pr = function Pr(r, e) {
  return Lr(wr(Ir(r)), function () {
    return wr(Ir(e));
  }, !1);
},
    Br = function Br(r, e) {
  return [].concat(_toConsumableArray(e), [r]);
},
    Nr = function Nr(r, e) {
  return r <= e;
},
    xr = function xr(r, e, t) {
  return t.slice(r, e);
},
    Cr = function Cr(r, e) {
  return Lr(Nr(r, 0), e, function () {
    return e.reduce(function (t, o, n) {
      return Lr(n % r, t, [].concat(_toConsumableArray(t), [xr(n, jr(n, r), e)]));
    }, []);
  });
},
    Tr = Object.prototype,
    kr = Object.entries,
    zr = Object.keys,
    Fr = Object.values,
    Wr = Tr.hasOwnProperty,
    _r = function _r(r) {
  return null === r;
},
    Dr = function Dr(r) {
  return void 0 === r;
},
    Mr = function Mr(r, e) {
  return wr(Ir(r)) || wr(Ir(e));
},
    qr = function qr(r) {
  return Mr(Dr(r), function () {
    return _r(r);
  });
},
    Gr = function Gr(r) {
  return !r;
},
    Hr = function Hr(r) {
  return Lr(Pr(Gr(qr(r)), function () {
    return r.constructor;
  }), function () {
    var _r$constructor$name2;

    return (_r$constructor$name2 = r.constructor.name) !== null && _r$constructor$name2 !== void 0 ? _r$constructor$name2 : "";
  }, "");
},
    Jr = function Jr(r) {
  return "number" == typeof r;
},
    Kr = Ur,
    Qr = function Qr(r) {
  return Jr(r) ? Kr(r, 1) : Kr(r, 1n);
},
    Vr = function Vr(r) {
  return Number.isNaN(r);
},
    Xr = function Xr(r) {
  return function (e) {
    return Mr(qr(e), function () {
      return Vr(e);
    }) ? r : e;
  };
},
    Yr = Er,
    Zr = function Zr(r) {
  return "string" == typeof r;
},
    $r = function $r(r, e) {
  return Lr(Zr(e), function () {
    return e.endsWith(r);
  }, function () {
    return function (e) {
      return $r(r, e);
    };
  });
},
    re = function re(r) {
  return kr(r);
},
    ee = Z,
    te = function te() {
  return !1;
},
    oe = function oe(r) {
  return Array.isArray(r);
},
    ne = function ne(r) {
  return r.length;
},
    se = function se(r, e) {
  return r < e;
},
    ie = function ie(r, e) {
  return Lr(se(r, 0), function () {
    return e.slice(r);
  }, function () {
    return xr(0, r, e);
  });
},
    ae = function ae(r) {
  return Lr(oe(r), function () {
    return Lr(ne(r), function () {
      return ie(1, r)[0];
    }, void 0);
  }, function () {
    return ie(1, r);
  });
},
    ce = function ce(r) {
  return r.flat(1 / 0);
},
    ye = function ye(r, e) {
  return r > e;
},
    le = function le(r, e) {
  return r >= e;
},
    ue = function ue(r, e) {
  return Wr.call(e, r);
},
    fe = function fe(r) {
  return Lr(Mr(Zr(r), function () {
    return oe(r);
  }), function () {
    return Gr(ne(r));
  }, !1);
},
    me = function me(r) {
  return "bigint" == typeof r;
},
    pe = function pe(r) {
  return "boolean" == typeof r;
},
    ge = function ge(r) {
  return Mr(Dr(r), function () {
    return _r(r);
  });
},
    be = function be(r) {
  return "symbol" == typeof r;
},
    de = function de(r) {
  return [ge, pe, Jr, Zr, me, be].some(function (e) {
    return e(r);
  });
},
    ve = function ve(r) {
  return Gr(de(r));
},
    Ae = function Ae(r) {
  return xr(1, 1 / 0, r);
},
    he = function he(r, e) {
  var t = ae(r);
  if (Dr(t)) return !1;
  var o = Ae(r);
  return fe(o) ? ue(t, e) : Lr(Pr(ue(t, e), function () {
    return ve(e[t]);
  }), function () {
    return he(o, e[t]);
  }, !1);
},
    Se = function Se(r, e) {
  return oe(r) ? he(r, e) : ue(r, e);
},
    Ee = he,
    Oe = function Oe(r) {
  return xr(0, -1, r);
},
    Ue = function Ue(r) {
  return r;
},
    je = function je(r, e, t) {
  return function (o) {
    return Lr(r(o), function () {
      return Lr(Rr(e), function () {
        return e(o);
      }, function () {
        return e;
      });
    }, function () {
      return Lr(Rr(t), function () {
        return t(o);
      }, function () {
        return t;
      });
    });
  };
},
    Re = function Re(r) {
  return Jr(r) ? jr(r, 1) : jr(r, 1n);
},
    we = r(function (r, e) {
  return r.includes(e);
}),
    Le = function Le(r) {
  return zr(r);
},
    Ie = function Ie(r) {
  return Mr(Zr(r), function () {
    return oe(r);
  }) ? fe(r) : !!ve(r) && Pr(fe(Le(r)), function () {
    return r.constructor === Object;
  });
},
    Pe = function Pe(r) {
  return "Object" === Hr(r);
},
    Be = function Be(r) {
  return function () {
    return r;
  };
},
    Ne = function Ne(r, e) {
  return Lr(Nr(r, 0), function () {
    return xr(0, -r, e);
  }, function () {
    return e.slice(-r);
  });
},
    xe = function xe(r) {
  return Lr(oe(r), function () {
    return Lr(ne(r), function () {
      return Ne(1, r)[0];
    }, void 0);
  }, function () {
    return Ne(1, r);
  });
},
    Ce = function Ce(r) {
  return r.toLowerCase();
},
    Te = function Te(r, e) {
  return oe(e) ? function (r, e) {
    return e.map(r);
  }(r, e) : function (r, e) {
    return re(e).reduce(function (t, _ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          o = _ref8[0],
          n = _ref8[1];

      return t[o] = r(n, o, e), t;
    }, {});
  }(r, e);
},
    ke = Or,
    ze = function ze(r) {
  return function () {
    return Gr(r.apply(void 0, arguments));
  };
},
    Fe = function Fe() {
  for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    r[_key2] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      e[_key3] = arguments[_key3];
    }

    return r.reduce(function (r, e, t) {
      return e.apply(void 0, _toConsumableArray(0 === t ? r : [r]));
    }, e);
  };
},
    We = function We(r, e) {
  return [r].concat(_toConsumableArray(e));
},
    _e = function _e(r) {
  var e = ae(r);
  return Lr(Dr(e), 0, function () {
    var t = Lr(Jr(e), 1, 1n);
    return r.reduce(ke, t);
  });
},
    De = function De(r, e) {
  return function (r, e) {
    return Lr(Se(r, e), function () {
      return e[r];
    }, void 0);
  }(r, e);
},
    Me = function Me(r, e, t) {
  return t.replace(r, e);
},
    qe = function qe(r, e, t) {
  return t.replaceAll(r, e);
},
    Ge = function Ge(r) {
  return Zr(r) ? r.split("").reverse().join("") : _toConsumableArray(r).reverse();
},
    He = function He(r, e) {
  return Lr(Zr(e), function () {
    return e.startsWith(r);
  }, function () {
    return function (e) {
      return He(r, e);
    };
  });
},
    Je = function Je(r) {
  var e = ae(r);
  return Lr(Dr(e), 0, function () {
    var t = Lr(Jr(e), 0, 0n);
    return r.reduce(jr, t);
  });
},
    Ke = function Ke() {
  return !0;
},
    Qe = function Qe(r) {
  return function (e) {
    return r(e), e;
  };
},
    Ve = r(function (r, e) {
  return r.test(e);
}),
    Xe = function Xe(r) {
  return r.trim();
},
    Ye = function Ye(r) {
  return r.trimLeft();
},
    Ze = function Ze(r) {
  return r.trimRight();
},
    $e = function $e(r, e) {
  try {
    return Ir(r);
  } catch (r) {
    return Lr(Rr(e), function () {
      return e(r);
    }, function () {
      return Lr(Gr(Dr(e)), e, r);
    });
  }
},
    rt = function rt(r) {
  return Array.from(new Set(r)).reduce(function (r, e) {
    var t = r.some(function (r) {
      return ee(e, r);
    });
    return Lr(t, r, function () {
      return [].concat(_toConsumableArray(r), [e]);
    });
  }, []);
},
    et = function et(r) {
  return r.toUpperCase();
},
    tt = function tt(r) {
  return Fr(r);
},
    ot = function ot(r, e) {
  return Gr(Ir(r)) !== Gr(Ir(e));
};
/*! Copyright (c) 2021-present the Fonction authors. All rights reserved. MIT license. */

/*! Copyright (c) 2021-present the Fonction authors. All rights reserved. MIT license. */

/*! Copyright (c) 2021-present the Fonction authors. All rights reserved. MIT license. */

/*! Copyright (c) 2021-present TomokiMiyauci. All rights reserved. MIT license. */


export { te as F, Be as K, Gr as N, wr as NN, Ke as T, hr as _, jr as add, Ir as advance, Pr as and, Br as append, Cr as chunk, Hr as constructorName, r as curry, Qr as dec, Xr as defaultTo, Yr as divide, $r as endsWith, re as entries, ee as equal, ae as first, ce as flattenDeep, ye as gt, le as gte, Se as has, Ee as hasPath, Oe as head, Ue as identity, Lr as ifElse, je as ifElseFn, Re as inc, we as includes, oe as isArray, me as isBigint, pe as isBoolean, Ie as isEmpty, Rr as isFunction, Pe as isJSONObject, fe as isLength0, Vr as isNaN, qr as isNil, ge as isNill, _r as isNull, Jr as isNumber, ve as isObject, de as isPrimitive, Zr as isString, be as isSymbol, Dr as isUndefined, Le as keys, xe as last, ne as length, Ce as lowerCase, se as lt, Nr as lte, Te as map, ke as multiply, ze as not, Mr as or, Fe as pipe, We as prepend, _e as product, De as props, Me as replace, qe as replaceAll, Ge as reverse, xr as slice, He as startsWith, Kr as subtract, Je as sum, Ae as tail, ie as take, Ne as takeLast, Qe as tap, Ve as test, Xe as trim, Ye as trimLeft, Ze as trimRight, $e as tryCatch, rt as uniq, et as upperCase, tt as values, ot as xor };